import { render, staticRenderFns } from "./ViewIngredientsPopup.vue?vue&type=template&id=e956bd3a&scoped=true&"
import script from "./ViewIngredientsPopup.vue?vue&type=script&lang=js&"
export * from "./ViewIngredientsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ViewIngredientsPopup.vue?vue&type=style&index=0&id=e956bd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e956bd3a",
  null
  
)

export default component.exports